import React from "react";

const DesignImg = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="731.66157"
      height="436.37988"
      viewBox="0 0 731.66157 436.37988"
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      role="img"
      artist="Katerina
      Limpitsouni"
      source="https://undraw.co/"
      className={className}
    >
      <path
        d="M871.49841,246.80994h-143.79v9.25a2.03965,2.03965,0,0,0,.46045,1.3c-.29,7.23005-.46045,16.46-.46045,26.49v247.3c0,23.18.93018,42.04,2.07032,42.04h139.6499c1.14014,0,2.06982-18.86,2.06982-42.04v-247.3c0-10.03-.16992-19.25994-.46-26.49a2.03925,2.03925,0,0,0,.46-1.3Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M869.42859,574.18994H729.77869c-1.08838,0-1.80738,0-2.46143-13.27832-.39258-7.96826-.60889-18.53808-.60889-29.76172V283.8501c0-9.69385.16382-19.11572.46119-26.53028.186-4.45166.39917-8.01757.6333-10.60009.45947-5.05567.89648-5.90967,1.97583-5.90967h139.6499c1.07935,0,1.51611.854,1.97583,5.90967.23462,2.59228.44751,6.1582.63306,10.59814l.00024.00195c.29712,7.40674.46069,16.82862.46069,26.53028V531.1499c0,11.22412-.21606,21.79395-.60864,29.76172C871.236,574.18994,870.517,574.18994,869.42859,574.18994Zm-139.08179-2H868.86047c.72364-2.73291,1.63794-17.57031,1.63794-41.04V283.8501c0-9.6753-.16308-19.06787-.459-26.44824h-.00024c-.18409-4.40821-.395-7.94141-.62647-10.50147a28.88406,28.88406,0,0,0-.56177-4.09033H730.35632a28.89649,28.89649,0,0,0-.56176,4.09033c-.2312,2.55029-.4419,6.0835-.62671,10.50147-.29615,7.38671-.45948,16.78027-.45948,26.44824V531.1499C728.70837,554.61914,729.62293,569.457,730.3468,572.18994Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M869.42859,241.80994H729.77869a2.07433,2.07433,0,0,0-2.07032,2.07v12.18a2.03965,2.03965,0,0,0,.46045,1.3,2.0795,2.0795,0,0,0,1.60987.77h139.6499a2.08023,2.08023,0,0,0,1.60986-.77,2.03925,2.03925,0,0,0,.46-1.3v-12.18A2.0739,2.0739,0,0,0,869.42859,241.80994Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#cacaca"
      />
      <circle
        id="b800b2fc-3bcc-4a40-9972-a80335d602c8"
        data-name="Ellipse 90"
        cx="505.55903"
        cy="17.56535"
        r="2.93962"
        fill="#fff"
      />
      <circle
        id="fa63cc97-e384-451c-9b8c-3b6845b8b0f6"
        data-name="Ellipse 91"
        cx="516.71687"
        cy="17.56535"
        r="2.93962"
        fill="#fff"
      />
      <circle
        id="beaeadfc-8efd-4e6c-adaf-945ac9d4d623"
        data-name="Ellipse 92"
        cx="527.87522"
        cy="17.56535"
        r="2.93962"
        fill="#fff"
      />
      <path
        d="M858.49841,245.45H845.64832a.95609.95609,0,0,0-.94971.95.80091.80091,0,0,0,.1001.41.94344.94344,0,0,0,.84961.54h12.85009a.948.948,0,0,0,.86036-.54.91378.91378,0,0,0,.08984-.41A.94956.94956,0,0,0,858.49841,245.45Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M858.49841,249.02H845.64832a.95.95,0,0,0,0,1.9h12.85009a.95.95,0,1,0,0-1.9Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M858.49841,252.59H845.64832a.95.95,0,0,0,0,1.9h12.85009a.95.95,0,1,0,0-1.9Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M813.49841,284.83H787.05847a5.002,5.002,0,0,0-5,5v22.9a5.0084,5.0084,0,0,0,5,5h26.43994a5.0147,5.0147,0,0,0,5-5v-22.9A5.00824,5.00824,0,0,0,813.49841,284.83Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M846.34851,332.68994h-92.1499a2.27,2.27,0,1,0,0,4.54h92.1499a2.27,2.27,0,1,0,0-4.54Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M789.19861,343.33h-35a2.27,2.27,0,1,0,0,4.54h35a2.27,2.27,0,1,0,0-4.54Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M813.49841,383.83H787.05847a5.002,5.002,0,0,0-5,5v22.9a5.0084,5.0084,0,0,0,5,5h26.43994a5.0147,5.0147,0,0,0,5-5v-22.9A5.00824,5.00824,0,0,0,813.49841,383.83Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M846.34851,431.68994h-92.1499a2.27,2.27,0,1,0,0,4.54h92.1499a2.27,2.27,0,1,0,0-4.54Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M789.19861,442.33h-35a2.27,2.27,0,1,0,0,4.54h35a2.27,2.27,0,1,0,0-4.54Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M813.49841,482.83H787.05847a5.002,5.002,0,0,0-5,5v22.9a5.0084,5.0084,0,0,0,5,5h26.43994a5.0147,5.0147,0,0,0,5-5v-22.9A5.00824,5.00824,0,0,0,813.49841,482.83Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M846.34851,530.68994h-92.1499a2.27,2.27,0,1,0,0,4.54h92.1499a2.27,2.27,0,1,0,0-4.54Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M789.19861,541.33h-35a2.27,2.27,0,1,0,0,4.54h35a2.27,2.27,0,1,0,0-4.54Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M688.49841,234.87994a2.0739,2.0739,0,0,0-2.06982-2.07H316.77869a2.07433,2.07433,0,0,0-2.07032,2.07v12.18a2.01687,2.01687,0,0,0,.53028,1.37c-.33008,8.27-.53028,19.17-.53028,31.11v274.91c0,25.78.93018,46.74,2.07032,46.74h369.6499c1.14014,0,2.06982-20.96,2.06982-46.74v-274.91c0-11.94-.1997-22.84-.52978-31.11a2.01645,2.01645,0,0,0,.52978-1.37Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M686.42859,602.18994H316.77869c-1.13,0-1.81214,0-2.46179-14.6582-.39246-8.855-.60853-20.60352-.60853-33.082V279.54c0-11.50733.1886-22.56983.53113-31.1499.65735-16.58008,1.406-16.58008,2.53919-16.58008h369.6499c1.13306,0,1.88184.00293,2.53931,16.58008h0c.342,8.57226.53051,19.63476.53051,31.1499V554.44971c0,12.479-.21606,24.22754-.60839,33.082C688.2406,602.18994,687.55847,602.18994,686.42859,602.18994Zm-369.06616-2H685.84485c.81811-3.13525,1.65356-20.74023,1.65356-45.74023V279.54c0-11.48926-.188-22.52393-.529-31.06983v-.00048c-.4165-10.50342-.90283-13.69971-1.13525-14.65967H317.37329c-.23254.96-.71887,4.15625-1.1355,14.65967-.34143,8.55468-.52942,19.58886-.52942,31.07031V554.44971C315.70837,579.44971,316.544,597.0542,317.36243,600.18994Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M686.42859,232.80994H316.77869a2.07433,2.07433,0,0,0-2.07032,2.07v12.18a2.01687,2.01687,0,0,0,.53028,1.37,2.05118,2.05118,0,0,0,1.54.7h369.6499a2.0512,2.0512,0,0,0,1.54-.7,2.01645,2.01645,0,0,0,.52978-1.37v-12.18A2.0739,2.0739,0,0,0,686.42859,232.80994Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#cacaca"
      />
      <circle
        id="b7005a6f-2f7f-4001-b097-d8b6c117468f"
        data-name="Ellipse 90"
        cx="92.55903"
        cy="8.56535"
        r="2.93962"
        fill="#fff"
      />
      <circle
        id="a0adf4f5-8105-4330-a35a-c3adb8f4e7bc"
        data-name="Ellipse 91"
        cx="103.71687"
        cy="8.56535"
        r="2.93962"
        fill="#fff"
      />
      <circle
        id="a64b73a5-7207-44c1-bcaf-f99ab7b9c6dc"
        data-name="Ellipse 92"
        cx="114.87522"
        cy="8.56535"
        r="2.93962"
        fill="#fff"
      />
      <path
        d="M675.49841,236.45H662.64832a.95.95,0,0,0,0,1.9h12.85009a.95.95,0,1,0,0-1.9Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M675.49841,240.02H662.64832a.95.95,0,0,0,0,1.9h12.85009a.95.95,0,1,0,0-1.9Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M675.49841,243.59H662.64832a.95.95,0,0,0,0,1.9h12.85009a.95.95,0,1,0,0-1.9Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M436.25867,293.83H392.99841a8.18973,8.18973,0,0,0-8.17968,8.18v37.47a8.18973,8.18973,0,0,0,8.17968,8.18h43.26026a8.18974,8.18974,0,0,0,8.17969-8.18V302.01A8.18974,8.18974,0,0,0,436.25867,293.83Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M614.68836,308.32H463.90857a3.715,3.715,0,0,0,0,7.43H614.68836a3.715,3.715,0,0,0,0-7.43Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M521.17859,325.72992h-57.27a3.715,3.715,0,0,0,0,7.43h57.27a3.715,3.715,0,0,0,0-7.43Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M436.25867,393.83H392.99841a8.18973,8.18973,0,0,0-8.17968,8.18v37.47a8.18973,8.18973,0,0,0,8.17968,8.18h43.26026a8.18974,8.18974,0,0,0,8.17969-8.18V402.01A8.18974,8.18974,0,0,0,436.25867,393.83Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M614.68836,408.32H463.90857a3.715,3.715,0,0,0,0,7.43H614.68836a3.715,3.715,0,0,0,0-7.43Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M521.17859,425.72992h-57.27a3.715,3.715,0,0,0,0,7.43h57.27a3.715,3.715,0,0,0,0-7.43Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M436.25867,493.83H392.99841a8.18973,8.18973,0,0,0-8.17968,8.18v37.47a8.18973,8.18973,0,0,0,8.17968,8.18h43.26026a8.18974,8.18974,0,0,0,8.17969-8.18V502.01A8.18974,8.18974,0,0,0,436.25867,493.83Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M614.68836,508.32H463.90857a3.715,3.715,0,0,0,0,7.43H614.68836a3.715,3.715,0,0,0,0-7.43Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M521.17859,525.72992h-57.27a3.715,3.715,0,0,0,0,7.43h57.27a3.715,3.715,0,0,0,0-7.43Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M752.43145,667.18994H504.78266c-1.14175,0-2.07052-17.54946-2.07052-39.12333v-230.134c0-21.57387.92877-39.12334,2.07052-39.12334H752.43145c1.14175,0,2.07052,17.54947,2.07052,39.12334v230.134C754.502,649.64048,753.5732,667.18994,752.43145,667.18994Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M752.43152,668.18994H504.78259c-1.0476,0-1.80468,0-2.46191-12.41846-.39258-7.415-.60864-17.2539-.60864-27.70507V397.93262c0-10.45069.21606-20.29.60864-27.70459.65723-12.41895,1.41431-12.41895,2.46191-12.41895H752.43152c1.04761,0,1.80469,0,2.46191,12.41895.39258,7.41455.60865,17.2539.60865,27.70459V628.06641c0,10.45117-.21607,20.29-.60865,27.70507C754.23621,668.18994,753.47913,668.18994,752.43152,668.18994Zm-247.09546-2h246.542c.71778-2.59082,1.624-16.394,1.624-38.12353V397.93262c0-21.7295-.90625-35.53272-1.624-38.12354h-246.542c-.71777,2.59082-1.624,16.394-1.624,38.12354V628.06641C503.712,649.7959,504.61829,663.59912,505.33606,666.18994Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M752.43145,375.12966H504.78266a2.07278,2.07278,0,0,1-2.07052-2.07051V360.87979a2.07279,2.07279,0,0,1,2.07052-2.07052H752.43145a2.07279,2.07279,0,0,1,2.07052,2.07052v12.17936A2.07278,2.07278,0,0,1,752.43145,375.12966Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#cacaca"
      />
      <circle
        id="a9432236-99f6-4733-9920-e312ad95354d"
        data-name="Ellipse 90"
        cx="280.55903"
        cy="134.56535"
        r="2.93962"
        fill="#fff"
      />
      <circle
        id="fc8d1cb9-e477-4d66-a241-a00170356ca4"
        data-name="Ellipse 91"
        cx="291.71687"
        cy="134.56535"
        r="2.93962"
        fill="#fff"
      />
      <circle
        id="bc1189a4-69b8-41a6-80e2-1e52c3b8abfb"
        data-name="Ellipse 92"
        cx="302.87522"
        cy="134.56535"
        r="2.93962"
        fill="#fff"
      />
      <path
        d="M741.49915,364.35211H728.65048a.95175.95175,0,0,1,0-1.90351h12.84867a.95176.95176,0,0,1,0,1.90351Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M741.49915,367.92118H728.65048a.95175.95175,0,0,1,0-1.9035h12.84867a.95175.95175,0,1,1,0,1.9035Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M741.49915,371.49026H728.65048a.95175.95175,0,0,1,0-1.90351h12.84867a.95176.95176,0,0,1,0,1.90351Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#fff"
      />
      <path
        d="M580.88245,450.72656H549.28922a5.98137,5.98137,0,0,1-5.97452-5.97452V417.38882a5.98137,5.98137,0,0,1,5.97452-5.97453h31.59323a5.98138,5.98138,0,0,1,5.97453,5.97453V444.752A5.98137,5.98137,0,0,1,580.88245,450.72656Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M711.187,427.42591H601.07653a2.71246,2.71246,0,0,1,0-5.42492H711.187a2.71246,2.71246,0,0,1,0,5.42492Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M642.89822,440.13986H601.07653a2.71245,2.71245,0,1,1,0-5.42491h41.82169a2.71246,2.71246,0,1,1,0,5.42491Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M580.88245,531.72656H549.28922a5.98137,5.98137,0,0,1-5.97452-5.97452V498.38882a5.98137,5.98137,0,0,1,5.97452-5.97453h31.59323a5.98138,5.98138,0,0,1,5.97453,5.97453V525.752A5.98137,5.98137,0,0,1,580.88245,531.72656Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M711.187,508.42591H601.07653a2.71246,2.71246,0,0,1,0-5.42492H711.187a2.71246,2.71246,0,0,1,0,5.42492Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M642.89822,521.13986H601.07653a2.71245,2.71245,0,1,1,0-5.42491h41.82169a2.71246,2.71246,0,1,1,0,5.42491Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M580.88245,612.72656H549.28922a5.98137,5.98137,0,0,1-5.97452-5.97452V579.38882a5.98137,5.98137,0,0,1,5.97452-5.97453h31.59323a5.98138,5.98138,0,0,1,5.97453,5.97453V606.752A5.98137,5.98137,0,0,1,580.88245,612.72656Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#2C55E5"
      />
      <path
        d="M711.187,589.42591H601.07653a2.71246,2.71246,0,1,1,0-5.42492H711.187a2.71246,2.71246,0,1,1,0,5.42492Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
      <path
        d="M642.89822,602.13986H601.07653a2.71245,2.71245,0,1,1,0-5.42491h41.82169a2.71246,2.71246,0,1,1,0,5.42491Z"
        transform="translate(-234.16922 -231.81006)"
        fill="#e4e4e4"
      />
    </svg>
  );
};

export default DesignImg;
